// Общие утилиты для Vue Messages

// Helper function to get current user ID
export const getCurrentUserId = (): string | number | null => {
  const w = window as any;
  const raw = w.__messagesCurrentUserId;
  if (raw === null || raw === undefined || raw === '') return null;
  const n = Number(raw);
  return Number.isFinite(n) && String(n) === String(raw) ? n : String(raw);
};

// Генерация уникального temp ID
export const generateTempId = (): string => {
  return 'temp-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
};

// Форматирование времени
export const formatTime = (timestamp: number | string): string => {
  const date = new Date(typeof timestamp === 'string' ? parseInt(timestamp) : timestamp * 1000);
  return date.toLocaleTimeString('ru-RU', { 
    hour: '2-digit', 
    minute: '2-digit' 
  });
};
